import { render, staticRenderFns } from "./PlatformSettled.vue?vue&type=template&id=d70c8a36&scoped=true&"
import script from "./PlatformSettled.vue?vue&type=script&lang=js&"
export * from "./PlatformSettled.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSettled.vue?vue&type=style&index=0&id=d70c8a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70c8a36",
  null
  
)

export default component.exports